import { type FunctionComponent } from 'react';
import {
	SHOWROOM_EXPERIENCE_CARD_DATA,
	SHOWROOM_EXPERIENCE_DESCRIPTION,
	SHOWROOM_EXPERIENCE_TITLE,
	SHOWROOM_EXPERIENCE_PREPARE_SECTION_DATA,
	SHOWROOM_EXPERIENCE_PREPARE_SECTION_DESCRIPTION,
	SHOWROOM_EXPERIENCE_PREPARE_SECTION_TITLE
} from '../../../../constants/showroom';
import { ShowroomMeetExpert } from '../../showroom-meet-expert/showroom-meet-expert.component';
import { ShowroomExperienceBackground } from '../showroom-experience-background/showroom-experience-background.component';
import { ShowroomExperienceContentCard } from '../showroom-experience-content-card/showroom-experience-content-card.component';
import { ShowroomExperienceContentCompactCard } from '../showroom-experience-content-compact-card/showroom-experience-content-compact-card.component';

export type ShowroomExperienceContainerProps = {
	searchOnClick: (input: string) => void;
};

export const ShowroomExperienceContainer: FunctionComponent<ShowroomExperienceContainerProps> = ({ searchOnClick }) => {
	return (
		<section className="relative flex flex-column items-center pb3 pb6-ns pt3 pt0-ns h-100 w-100">
			<div className="flex flex-column gr4 ph3 ph0-l z-2" style={{ maxWidth: 1280 }}>
				<div className="flex flex-column gr4">
					<div className="flex flex-column gr1" style={{ maxWidth: 750 }}>
						<h2 className="ma0 pa0 f3 f2-ns lh-title b theme-grey-darker">{SHOWROOM_EXPERIENCE_TITLE}</h2>
						<p className="ma0 pa0 f6 f5-ns lh-copy fw4 theme-grey-dark">{SHOWROOM_EXPERIENCE_DESCRIPTION}</p>
					</div>
					<div className="dn flex-ns flex-column gr4">
						{SHOWROOM_EXPERIENCE_CARD_DATA.map((card) => (
							<ShowroomExperienceContentCard key={card.title} {...card} />
						))}
					</div>
					<div className="flex dn-ns flex-column gr3">
						{SHOWROOM_EXPERIENCE_CARD_DATA.map((card) => (
							<ShowroomExperienceContentCompactCard key={card.title} {...card} />
						))}
					</div>
				</div>
				<div className="flex flex-column gr4">
					<div className="flex flex-column gr1" style={{ maxWidth: 750 }}>
						<h2 className="ma0 pa0 f3 f2-ns lh-title b theme-grey-darker">{SHOWROOM_EXPERIENCE_PREPARE_SECTION_TITLE}</h2>
						<p className="ma0 pa0 f6 f5-ns lh-copy fw4 theme-grey-dark">{SHOWROOM_EXPERIENCE_PREPARE_SECTION_DESCRIPTION}</p>
					</div>
					<div className="flex flex-row ga3 flex-wrap justify-center-m">
						{SHOWROOM_EXPERIENCE_PREPARE_SECTION_DATA.map((card) => (
							<ShowroomExperienceContentCompactCard key={card.title} {...card} />
						))}
					</div>
				</div>
				<div className="mt6">
					<ShowroomMeetExpert searchOnClick={searchOnClick} />
				</div>
			</div>
			<ShowroomExperienceBackground />
		</section>
	);
};
